import React from 'react'
import { createRoot } from 'react-dom/client'
import SharePage from './SharePage.jsx'
import App from './App.jsx'

// If this is a public share link, render the share page instead of the upload app
const shareMatch = window.location.pathname.match(/^\/share\/([^/]+)/)

createRoot(document.getElementById('root')).render(
    shareMatch
        ? <SharePage shareId={shareMatch[1]} />
        : <App />
)
